import { Founder } from "@/components/landing/Founder";
import { PageFooterNav } from "@/components/landing/PageChrome";
import { SEO } from "@/components/SEO";

export default function PageFounder() {
  return (
    <>
      <SEO
        title="Le fondateur — Wilson Eric"
        description="Rencontrez Wilson Eric, ingénieur béninois, fondateur de Whilsco-Digit SARL et de la marketplace Zafara Bénin."
        path="/fondateur"
      />
      <Founder />
      <PageFooterNav
        prev={{ to: "/application", label: "L'application" }}
        next={{ to: "/whilsco-digit", label: "Whilsco-Digit" }}
      />
    </>
  );
}
